import { render, staticRenderFns } from "./siteAdminLogList.vue?vue&type=template&id=09701d2c&scoped=true&"
import script from "./siteAdminLogList.vue?vue&type=script&lang=babel&"
export * from "./siteAdminLogList.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09701d2c",
  null
  
)

export default component.exports